export const GET_MEMBERS_LIST = 'GET_MEMBERS_LIST';
export const SET_MEMBERS_LIST = 'SET_MEMBERS_LIST';
export const SET_SELECTED_FACILITY_ID = 'SET_SELECTED_FACILITY_ID';
export const SET_MEMBERS_TOTAL_COUNT = 'SET_MEMBERS_TOTAL_COUNT';
export const SET_SELECTED_MEMBERS = 'SET_SELECTED_MEMBERS';
export const JOIN_MEMBERS_LIST = 'JOIN_MEMBERS_LIST';
export const SET_MEMBER_TO_DEACTIVATE = 'SET_MEMBER_TO_DEACTIVATE';
export const DEACTIVATE_MEMBER = 'DEACTIVATE_MEMBER';

